<app-header></app-header>
<div id="main_app" class="container-fluid">
  <div class="container">
    <div class="head_profile">
      <div class="image_profile">
              <img src="{{userInfo.picture}}" width="100%" height="100%" alt="">
        <mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="cardSpinner"></mat-spinner>
      </div><!-- .image_profile -->
      <div class="detail_profile">
        <div class="row_detail_profile">
          <span>{{ 'FullName' | translate}}:</span>
          {{userInfo.name}}
          <mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="cardSpinner"></mat-spinner>
          |
          <span>&nbsp;{{ 'MobileNumber' | translate}}:</span>
          {{userInfo.mobile}}
          <mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="cardSpinner"></mat-spinner>
        </div>
        <div class="row_detail_profile">
          <span>{{ 'TimeAllPomodoro' | translate}}:</span>
          {{userTaskInfo.sumDurationPomodoro}}
          <mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="cardSpinner"></mat-spinner>
        </div>
        <div class="row_detail_profile">
          <span>{{ 'NumberAllPomodoro' | translate}}:</span>
<!--          {{numberAllPomodoro}}-->
          {{userTaskInfo.sumCountPomodoro}}
          <mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="cardSpinner"></mat-spinner>
        </div>
        <div class="row_detail_profile">
          <span>{{ 'RankingInAllUsers' | translate}}:</span>
          <ng-container *ngIf="pomodoroRepository.beInPomodoroRanking"> {{userRank}}
            <mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="cardSpinner"></mat-spinner></ng-container>
          <ng-container *ngIf="!pomodoroRepository.beInPomodoroRanking">
            {{'AbsenceFromRanking' | translate}}
            <a [routerLink]="['/Statistics']">{{ 'ClickToParticipateInTheGeneralUserRanking' | translate}}</a>
          </ng-container>
        </div>
        <div class="profile-btn-wrapper">
          <a class="chart_btn" [routerLink]="['/charts']">{{ 'ViewCharts' | translate}}</a>
          <a class="reminder_btn" [routerLink]="['/reminder']">{{ 'SMSReminder' | translate}}</a>
        </div>
      </div><!-- .detail_profile -->
      <div class="edit-profile" [routerLink]="['/edit']">{{ 'EditInformationTitle' | translate}}</div>
      <div class="clearfix"></div>
    </div><!-- .head_profile -->
    <div class="ranking_title">{{ 'WorkDoneTitle' | translate}}</div>
    <div class="ranking_excerpt">
      {{ 'WorkDoneDescription' | translate}}
    </div>
    <div class="top_table">
      <div class="ranking_allow">
        <div class="ranking_allow_title">
          {{ 'FilterBy' | translate}}:
        </div>
        <div class="ranking_allow_switch">
          <select class="category_tasks_profile" (change)="sendCategory($event)" [value]="selectedCat">
            <option class="all-cat" (click)="getTodayTask()">{{pomodoroRepository.allCategory}}</option>
            <option *ngFor="let category of pomodoroRepository.categories" [value]="category">
              {{category}}
            </option>
          </select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="ranking_filter">
        <ul>
          <li (click)="onClick(4)" [ngClass]="{'active': tab==='tab4'}">
            <a (click)="getThisMonthTask()">{{ 'ThirtyDaysAgo' | translate }}</a>
          </li>
          <li (click)="onClick(3)" [ngClass]="{'active': tab==='tab3'}">
            <a (click)="getThisWeekTask()">{{ 'SevenDaysAgo' | translate }}</a>
          </li>
          <li (click)="onClick(2)" [ngClass]="{'active': tab==='tab2'}">
            <a (click)="getYesterdayTask()">{{ 'Yesterday' | translate }}</a>
          </li>
          <li class="active" (click)="onClick(1)" [ngClass]="{'active': tab==='tab1'}">
            <a (click)="getTodayTask()">{{ 'Today' | translate }}</a>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>
    <table class="ranking_table">
      <tr>
        <th>{{ 'Row' | translate}}</th>
        <th>{{ 'Category' | translate}}</th>
        <th>{{ 'Title' | translate}}</th>
        <th>{{ 'Duration' | translate}}</th>
        <th>{{ 'NumberOfPomodoros' | translate}}</th>
      </tr>
      <div class="spinner-line"><mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="spinner"></mat-spinner></div>
      <tr *ngFor="let item of pomoDate | paginate: { itemsPerPage: 10, currentPage: p }; let i = index">
        <td>{{i+1}}</td>
        <td>{{item.category}}</td>
        <td>{{item.description}}</td>
        <td>{{item.time_length}}</td>
        <td>{{item.count}}</td>
      </tr>
      <tr class="you_are">
        <td>{{ 'TheEnd' | translate}}</td>
        <td>
          -
        </td>
        <td>{{ 'AllOfWork' | translate}}</td>
        <td>{{formatHour}}</td>
        <td>{{countFormat}}</td>
      </tr>
    </table>
    <div class="row">
      <div class="row justify-content-center align-items-center mt-4">
        <ng-container *ngIf="tab == 'tab1'">
          <pagination-controls *ngIf="showPagination" class="my-pagination"
                               (pageChange)="p = $event"
                               previousLabel="{{'Previous' | translate}}"
                               nextLabel="{{'Next' | translate}}"
                               directionLinks="true"
          ></pagination-controls>
        </ng-container>
        <ng-container *ngIf="tab == 'tab2'">
        <pagination-controls *ngIf="showPagination" class="my-pagination"
                             (pageChange)="p = $event"
                             previousLabel="{{'Previous' | translate}}"
                             nextLabel="{{'Next' | translate}}"
                             directionLinks="true"
        ></pagination-controls>
        </ng-container>
        <ng-container *ngIf="tab == 'tab3'">
        <pagination-controls *ngIf="showPagination" class="my-pagination"
                             (pageChange)="p = $event"
                             previousLabel="{{'Previous' | translate}}"
                             nextLabel="{{'Next' | translate}}"
                             directionLinks="true"
        ></pagination-controls>
        </ng-container>
        <ng-container *ngIf="tab == 'tab4'">
        <pagination-controls *ngIf="showPagination" class="my-pagination"
                             (pageChange)="p = $event"
                             previousLabel="{{'Previous' | translate}}"
                             nextLabel="{{'Next' | translate}}"
                             directionLinks="true"
        ></pagination-controls>
        </ng-container>
      </div>
    </div>
  </div><!-- .container -->
</div><!-- #main_app -->
<router-outlet></router-outlet>
<app-footer></app-footer>
